import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { prefetchRoutes } from './lib/performance';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Remove StrictMode in production for better performance
if (process.env.NODE_ENV === 'production') {
  root.render(<App />);
} else {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

// Prefetch critical routes after initial render
if ('requestIdleCallback' in window) {
  window.requestIdleCallback(() => {
    prefetchRoutes();
  });
} else {
  setTimeout(() => {
    prefetchRoutes();
  }, 2000);
}

